import { Col, Row, Tab } from 'react-bootstrap';
import useModule from '../../hooks/theory/useModule';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ModuleImageAndTitle from '../../components/molecules/Theory/Module/ModuleImageAndTitle';
import ModuleProgress from '../../components/molecules/Theory/Module/ModuleProgress';
import HorizontalTabNav from '../../components/organisms/Tab/Horizontal/HorizontalTabNav';
import HorizontalTabContent from '../../components/organisms/Tab/Horizontal/HorizontalTabContent';
import { TabItem } from '../../types/tabItem';
import ModuleChapters from '../../components/molecules/Theory/Module/ModuleChapters';
import ModuleDescription from '../../components/molecules/Theory/Module/ModuleDescription';
import CommentsCard from '../../components/organisms/CommentsCard/CommentsCard';
import PageTitle from '../../components/atoms/PageTitle/PageTitle';
import { SeoEntityType } from '../../types/cms/seoData';
import { SeoDetails } from '../../components/atoms/CMS/SeoDetails';
import { LoggedOutAlert } from '../../components/atoms/CMS/LoggedOutAlert';
import useSeo from '../../hooks/cms/useSeo';
import { AdsContainer, AdType } from '../../components/atoms/AdsContainer/AdsContainer';
import Spinner from '../../components/atoms/Spinner/Spinner';

const ModuleDetailsPage = () => {
    const { moduleSlug } = useParams<{ moduleSlug: string }>();
    const { t } = useTranslation();

    const { loading, userModuleDetails, userLoadModuleDetails, userDefaultTab, error } = useModule();
    const { userSeoDetails } = useSeo();

    useEffect(() => {
        userLoadModuleDetails(moduleSlug!!);
    }, [moduleSlug]);

    const moduleTabNavItems: TabItem[] = [
        {
            id: '1',
            key: 'module-description',
            icon: 'mdi mdi-book-information-variant',
            title: t('module.description'),
            component: <ModuleDescription content={userModuleDetails?.content} />,
        },
        {
            id: '2',
            key: 'module-chapters',
            icon: 'mdi mdi-bookmark-multiple-outline',
            title: t('module.chapters'),
            component: <ModuleChapters moduleSlug={moduleSlug!!} moduleHasStarted={userModuleDetails?.isStarted} />,
        },
        {
            id: '3',
            key: 'module-comments',
            icon: 'mdi mdi-comment-multiple-outline',
            title: t('comment.plural'),
            component: <CommentsCard domain={'modules'} domainId={userModuleDetails?.id} />,
        },
    ];

    return (
        <>
            <SeoDetails type={SeoEntityType.MODULE} slug={moduleSlug ?? ''} />
            <LoggedOutAlert />
            {!userModuleDetails && (
                <Row className={'justify-content-center align-items-center'} style={{ height: '800px' }}>
                    <Spinner size='sm' className='mb-sm-1' color={'primary'} />
                </Row>
            )}
            {userModuleDetails && (
                <>
                    <PageTitle
                        breadCrumbItems={[
                            { label: t('module.plural'), path: '/modules' },
                            { label: userModuleDetails.title, path: '/modules/' + moduleSlug, active: true },
                        ]}
                        title={t('module.plural')}
                    />
                    <Row>
                        <hr className='hr hr-blurry' />
                    </Row>
                    <ModuleImageAndTitle module={userModuleDetails} />
                    <ModuleProgress module={userModuleDetails} />
                    <Tab.Container defaultActiveKey={userDefaultTab}>
                        <Col className='my-3'>
                            <HorizontalTabNav content={moduleTabNavItems} />
                        </Col>
                        <Col>
                            <HorizontalTabContent content={moduleTabNavItems} />
                        </Col>
                    </Tab.Container>
                    <AdsContainer type={AdType.LANDSCAPE_LARGE} />
                </>
            )}
        </>
    );
};

export default ModuleDetailsPage;
